import { Component } from '@angular/core';
import { UserDetailsComponent } from 'gung-standard';

@Component({
    selector: 'cult-cult-user-details',
    templateUrl: './cult-user-details.component.html',
    styleUrls: ['./cult-user-details.component.scss'],
    standalone: false
})
export class CultUserDetailsComponent extends UserDetailsComponent {}
